<style lang="scss" scoped>
.banner-wrap {
  position: relative;
  width: 100%;
  min-height: 750px;
  color: #ffffff;
  font-size: 24px;

  .good-tag {
    position: absolute;
    top: 128px;
    left: 32px;
    z-index: 95;
    height: 56px;

    .img-wrap {
      position: absolute;
      top: -22px;
      left: -22px;
      width: 56px;
      height: 56px;
      .good {
        width: 128px;
        height: 116px;
        margin-top: 14px;
        margin-left: 36px;
      }
    }
    .real {
      height: 56px;
      border-radius: 28px;
    }
  }
  .show-enter-active {
    animation: show-in 0.3s;
  }
  .show-leave-active {
    animation: show-in 0.3s reverse;
  }

  @keyframes show-in {
    0% {
      width: 56px;
    }
    100% {
      width: 198px;
    }
  }
}
</style>

<template>
  <section class="banner-wrap">
    <carousel
      v-if="baseInfoMsg && baseInfoMsg.pics"
      :bannerData="bannerData"
      :originPics="baseInfoMsg.picIds"
      :mainImageToolList="baseInfoMsg.mainImageToolList"
      :warehouseInfo="(baseInfoMsg.deliveryInfo && baseInfoMsg.deliveryInfo.warehouseInfo) || ''"
      :detailDrawing="
        moreInfoMsg.detailDrawing &&
        moreInfoMsg.detailDrawing.map((i) => $setPicSize(i, 1000, 1000))
      "
      :reportItem="moreInfoMsg.report && moreInfoMsg.report.reportItem"
      :statusHeight="statusHeight"
      :detailDrawingIds="moreInfoMsg.detailDrawingIds"
      :detailDrawingNewObj="moreInfoMsg.detailDrawingNewObj"
      :videoVos="videoVos"
      :infoType="baseInfoMsg.infoType"
      :dataInfo="dataInfo"
      @listenMatching="listenMatching"
    ></carousel>
  </section>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from '@vue/composition-api'
import Carousel from './carousel'
import { setTimeoutPrecision } from '@utils/index'
import { state } from '@/store/index'

export default defineComponent({
  components: {
    Carousel
  },
  props: {
    statusHeight: {
      type: Number,
      default: 0
    },
    baseInfoMsg: {
      type: Object,
      default: () => {
        return {}
      }
    },
    moreInfoMsg: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dataInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, ctx) {
    const { $tiktok } = ctx.root
    console.log(props, 'moreInfoMsg')
    // 存在视频的情况下，轮播数据加一条
    const bannerData = computed(() => {
      const bannerInfo = props.baseInfoMsg?.pics?.slice()
      if (videoVos.value.url) {
        bannerInfo.unshift(bannerInfo[0])
      }

      console.info('bannerInfo', props.baseInfoMsg)
      return bannerInfo
    })
    $tiktok('created', 'banner')
    const videoVos = computed(() => {
      const videoVos = props.baseInfoMsg?.videoList?.length
        ? props.baseInfoMsg.videoList[0]
        : { url: '' }
      // const videoVos = {
      //   url: 'https://vod1.zhuanstatic.com/c55dd6c2vodgzp1255305554/ebdba44f5285890818611775513/yoUJW4mqL5gA.mp4',
      // }
      return videoVos
    })
    const showText = ref(true)

    const detailDrawing = computed(() => {
      return props.moreInfoMsg.detailDrawing
    })

    const listenMatching = (tabname, index) => {
      ctx.emit('listenMatching', tabname, index)
    }

    onMounted(() => {
      $tiktok('mounted', 'banner')
      setTimeoutPrecision(() => {
        showText.value = false
      }, 3000)
    })
    return { showText, bannerData, videoVos, detailDrawing, state, listenMatching }
  }
})
</script>
